
import { Component, Prop, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";
import DealerOfferItem from "~/components/organisms/display/DealerOfferItem.vue";
import { translateErrorMessage } from "~/defaults/heizoelpreise/errorCodeMessages";
import { translatePelletsErrorMessage } from "~/defaults/pellets/pelletsErrorMessages";

@Component({
  components: {
    DealerOfferItem,
    RouterLink,
  },
  methods: {
    translateErrorMessage,
    translatePelletsErrorMessage,
  },
})
export default class DealerOfferList extends Vue {
  @Prop({ required: true }) dealerOffers!: any[];
  @Prop({ required: true }) showPriceOffers!: boolean;
  @Prop({ required: true }) dealRequirements!: any;
  @Prop({ default: "" }) errorMessage!: string;
  @Prop({ default: false }) showPaletColumn!: boolean;
  @Prop({ default: "" }) selectPelletsOption!: string;
  @Prop({ default: false }) isPelletsSite!: boolean;
  @Prop({
    default:
      'Bitte bestätigen Sie den "Rechnen" Button, um Ihre aktualisierten Ergebnisse zu erhalten.',
  })
  overlayMessage!: string;

  translateErrorMessage = translateErrorMessage;

  translatePelletsErrorMessage = translatePelletsErrorMessage;

  get showDealerOffers(): boolean {
    return this.errorMessage === "" && this.dealerOffers.length > 0;
  }

  get translatedErrorMessage() {
    if (this.isPelletsSite) {
      return this.translatePelletsErrorMessage(
        this.errorMessage,
        this.selectPelletsOption,
      );
    }

    return this.translateErrorMessage(this.errorMessage);
  }
}
